<template>
  <SettingLanguage v-if="mode === '1'" v-bind="$attrs" v-on="$listeners" @handleSetLanguage="confirm" />
  <LangDropdown v-else @handleSetLanguage="confirm" />
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { setUserConfig } from '@/api/user.js'
// import { get_userInfo } from '@/lib/business-api'
import { isNotNeedLoginPage } from '@/lib/business'
import LangDropdown from './dropdown.vue'
import SettingLanguage from './setting-language.vue'
// import { loadLanguage } from '@/lang' // Import the loadLanguage function

export default {
  name: 'LangDropDown',
  components: {
    LangDropdown,
    SettingLanguage
  },
  inject: ['reload'],
  props: {
    mode: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState(['userInfo', 'languageList']),
    ...mapGetters(['language']),
    dir() {
      return this.language === 'ar' ? 'rtl' : 'ltr'
    }
  },
  mounted() {
    this.setDir()
  },
  methods: {
    // 切换语言
    confirm(lang) {
      // 当前如果是在未登录的页面，则无需调用设置接口，因为用户未登录
      if (!isNotNeedLoginPage()) {
        this.setUserConfig(lang)
      } else {
        // 未登录的情况设置本地缓存
        this.$store.commit('setTempLang', lang.value)
        this.setDir()
        this.$nextTick(() => {
          location.reload()
        })
      }
    },
    async setUserConfig(lang) {
      const param = {
        preferenceLanguage: lang.code
      }
      const data = await setUserConfig(param).catch(() => {})
      // 如果设置语言成功，则重新获取用户信息 正常流程
      if (data?.code === 0) {
        this.$message({
          message: this.$t('Ticket.Success'),
          type: 'success',
          duration: 1e3
        })
        this.$store.commit('setTempLang', lang.value)
        // await get_userInfo(this.$store)
        this.setDir()
        this.$nextTick(() => {
          setTimeout(() => {
            location.reload()
          }, 1000)
        })
      } else {
        // 如果设置语言失败，报错提示
        // this.$message({
        //   message: this.$t('Ticket.Failure'),
        //   type: 'error',
        //   duration: 1e3
        // })
      }
    },
    setDir() {
      const htmlEl = document.querySelector('html')
      htmlEl.setAttribute('dir', this.dir)
      htmlEl.setAttribute('lang', this.language)

      // Ensure document direction is also set for CSS
      document.body.style.direction = this.dir
    }
  }
}
</script>
